import { logError } from "./log";

export const isDarkMode = async (): Promise<boolean> => {
  try {
    // Optional chaining for safety
    const isDark = await (
      chrome as any)?.avast?.themes?.getDarkModeEnabled?.();

    if (typeof isDark === "boolean") {
      // Persist only if storage is available
      const storage = (chrome as any)?.storage?.local;
      if (storage?.set) {
        await storage.set({ "isDarkMode": isDark });
      }
      return isDark;
    }
    // If isDark is not a boolean (e.g., undefined, or API path was incomplete),
  } catch (avastError) {
    logError("Error checking Avast dark mode:", avastError);
    // Fall through to matchMedia on error
  }

  // Fallback to prefers-color-scheme
  try {
    if (window && window.matchMedia) {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
  } catch (matchMediaError) {
    logError("Error checking prefers-color-scheme:", matchMediaError);
  }
  const storage = (chrome as any)?.storage?.local;
  if (!storage?.get) {
    return false;
  }
  const savedIsDarkMode = (await storage.get("isDarkMode")).isDarkMode === true;
  return savedIsDarkMode;
};
